
const routes = {
  home: '/',
  curriculum: '/curriculum',
  pokedex: '/pokedex',
}

export {
  routes
}
